import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
      <h2>Introduction</h2>
        <h3>Counseling available in English and Farsi.</h3>
        <p>
        Hello, and welcome. My name is Hoda. Life may feel overwhelming, confusing, stuck, and/or challenging at times. My aim is to provide a collaborative, supportive, and judgement-free environment where you can learn more about yourself and feel accepted and supported throughout your therapeutic journey. I believe in exploring your unique stories, life experiences, strengths, and transitions. I enjoy working with people from diverse cultural and life experiences
        </p>
        <p>
        Do you struggle to set boundaries with family, partners, or even at work? And when you try, does guilt, shame, or self-doubt take over? You’re not alone. If you grew up without strong emotional role models or with emotionally immature parents, your caregivers may have had trouble handling their feelings—or yours. I can help you navigate these patterns so you can build self-esteem, make clearer choices, and create healthier relationships. Over time, this work can lead to stronger boundaries, deeper connections, and a greater sense of peace.
        </p>
        <p>
        While we may talk about difficult things, I also aspire to bring patience, empathy, a sense of humor, warmth, and care into our sessions.
        </p>

        <br />
        <br />
      </Wrap>
    </>
  );
};

export default Content;
